import styles from './PlanBadge.module.css';

const PLAN_COLORS: Record<string, string> = {
  trial: styles.trial ?? '',
  free: styles.free ?? '',
  basic: styles.basic ?? '',
  pro: styles.pro ?? '',
  enterprise: styles.enterprise ?? '',
  forever: styles.forever ?? '',
};

interface PlanBadgeProps {
  plan: string;
}

export function PlanBadge({ plan }: PlanBadgeProps) {
  return (
    <span className={`${styles.badge} ${PLAN_COLORS[plan] ?? ''}`}>
      {plan.charAt(0).toUpperCase() + plan.slice(1)}
    </span>
  );
}
